import { render, staticRenderFns } from "./PreferencesModal.vue?vue&type=template&id=b5a1a5fe&"
import script from "./PreferencesModal.vue?vue&type=script&lang=js&"
export * from "./PreferencesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports